import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import QuestionSetMenuItem from './QuestionSetMenuItem'
import {routeHelper} from '#config/routeKeys'

function AusbildungsplanQuestionSets({currentItem, contextualUserId, ready, findParent}) {
  const [questionSets, setQuestionSets] = useState([])
  useEffect(() => {
    // this allows us to keep displayed items during navigation
    if (!currentItem || !ready) {
      return
    }
    const subchapter = findParent(currentItem)
    const newQuestionSets = subchapter ? subchapter.content : []
    setQuestionSets(newQuestionSets)
  }, [currentItem, ready])
  return (
    <div data-menu="questionsets">
      <ul className="menu__level">
        {questionSets.map(qs => {
          if (!qs.content || !qs.content[0] || !qs.content[0].content) {
            return null
          }
          const questionsTotal = qs.content[0].content.length
          return (
            <li key={qs.id} className="menu__item">
              <QuestionSetMenuItem
                text={qs.text}
                chapterId={qs.id}
                userId={contextualUserId}
                url={routeHelper.ausbildungsplanQuestionsChapter(contextualUserId, qs.id)}
                questionsTotal={questionsTotal}
                active={currentItem === qs.id}
              />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

AusbildungsplanQuestionSets.propTypes = {
  contextualUserId: PropTypes.number.isRequired,
  currentItem: PropTypes.string,
  findParent: PropTypes.func,
  ready: PropTypes.any,
}

export default AusbildungsplanQuestionSets
